// extracted by mini-css-extract-plugin
module.exports = {"AdminLinks":"cBMQVSaf"};